import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { inject, observer } from "mobx-react";
import * as mobx from 'mobx'
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import debounce from 'lodash/debounce';
import Filters from './Options/Filters'
import States from './Options/States'
import Destinations from './Options/Destinations'
import Budget from './Options/Budget'
import Review from './Options/Review'
import CampaignType from './Options/CampaignType'
import CampiagnFailureDialog from './Options/Dialogs/CampiagnFailureDialog'
import CampiagnSuccessfulDialog from './Options/Dialogs/CampiagnSuccessfulDialog'
import NoCreditDialog from './Options/Dialogs/NoCreditDialog'
import NoDestinationDialog from './Options/Dialogs/NoDestinationDialog'
import AddCreditDialog from '../../AddCreditDialog'

const styles = theme => ({
  root: {
    minWidth: '90%',
    minHeight: '90%',
    marginBottom:  theme.spacing.unit * 3,
  },
  button: {
    marginRight: theme.spacing.unit,
  },
  instructions: {
    marginTop: theme.spacing.unit, 
    marginBottom: theme.spacing.unit,
  },
});

function getSteps() {
  return ['Choose your campaign type', 'Choose your filters', 'Select your states', 'Pick your destinations', 'Add Budget', 'Review'];
}


@inject("commonStore")
@inject("authStore")
@observer
class CampaignSetup extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      campaignStatus: 'active',
      showCreditDialog: false,
      updatingCampaign: false,
      loading: true,
      leadType: null,
      //leadTypes: ['exclusive'],
      qualifiers:[],
      contactTypes:[],
      "conditionsAllowed": [
        "none",
        "stroke",
        "cancer",
        "diabetes",
        "aids_hiv",
        "heart_attack",
        "pulmonary_disease"
      ],
      priceLevelsAllowed:[
        "0",
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9"
      ],
      activeStep: 0,
      skipped: new Set(),
      destinations: [],
      sharedLimit: 0,
      verticalType: 'health',
      isAgent: true,
     // leadAgeDelay: 0, // 2 hours for seth only
      maxAgeAllowed: 86400000, // 24 hours
     // minimumRefresh: 259200000, //72 hours
      incomplete: [],
      amount: 0,
      agreed: false,
      showedNoDestination: false,
      showNoDestination: false,
      showedNoCredit: false,
      showNoCredit: false,
      showCampaignSuccess: false,
      showCampaignFail: false,
      priceMapType: null,
      allowSpanish: false,
      allowEnglish: true,
      healthy:true,
     // priceMaps:{},
      fixedCampaignName:'',
      companyCampaignName:'',
      filters: {
        topLevel:[{
          "field": "region",
          "include": [],
          "recordType": "profile"
        },
        {
          "field": "vendor",
          "include": ['sonic'],
          "recordType": "lead"
        }
        ],
          exclusive:{
            qualifiers:{
                standard:{
                  phone:[],
                  email_only:[],
                  live_transfer:[]
                },
                split_policy:{
                  phone:[],
                  email_only:[],
                  live_transfer:[]
                }
            }
          },
          shared:{
            qualifiers:{
              standard:{
                  phone:[],
                  email_only:[],
                  live_transfer:[]
                },
                split_policy:{
                  phone:[],
                  email_only:[],
                  live_transfer:[]
                }
            }
          },
          recycled:{
            qualifiers:{
              standard:{
                  phone:[],
                  email_only:[],
                  live_transfer:[]
              },
              split_policy:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
              }
          }
        } 
      } 
  }
  }

  componentDidMount() {
    const { campaign, commonStore, authStore } = this.props
    const { agent } = commonStore
    const { agentID, defaults, credit } = agent

    /*if(credit < 1){
      this.setState({showCreditDialog:true})
    }*/

    this.updateWindowDimensions();
    window.addEventListener('resize', this.updateWindowDimensions);
    let activeStep = 0
    if(campaign){
      const { campaignID } = campaign
      console.log('got campaign')
      console.log(campaign)
      if(campaignID){
        console.log('got campaign')
        console.log(campaignID)
        activeStep = 1
        authStore.getCampaign(campaignID)
        .then(result => {
          console.log('got campaifn from db')
          const { campaign: campaignRaw } = commonStore
          const campaign = mobx.toJS(campaignRaw)
          const { region, povertyLevel, condition, qualifier, leadType, contactType, destinations, campaignName, allowEmail, allowPhone, minimumRefresh, maxAgeAllowed } = campaign
          this.setState({...campaign, amount:0, activeStep:1, loading: false})
          authStore.getDestinations(agentID)
          return
        })
      }else{
        this.setState({loading: false})
      }
    }else{
      this.setState({loading: false})
    }
    authStore.getDestinations(agentID)
    
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    this.setState({ height, width });
  }
  makeDefaultFilters = () => {

        return {
          topLevel:[{
            "field": "region",
            "include": [],
            "recordType": "profile"
          },
          {
            "field": "vendor",
            "include": ['sonic'],
            "recordType": "lead"
          }
          ],
            exclusive:{
              qualifiers:{
                  standard:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
                  },
                  split_policy:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
                  }
              }
            },
            shared:{
              qualifiers:{
                standard:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
                  },
                  split_policy:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
                  }
              }
            },
            recycled:{
              qualifiers:{
                standard:{
                    phone:[],
                    email_only:[],
                    live_transfer:[]
                },
                split_policy:{
                      phone:[],
                      email_only:[],
                      live_transfer:[]
                }
            }
          } 
        } 
  }
  closeCampaignDialog = (result) => {
    const { campaignFinished } = this.props
    if(result){
      console.log('result')
      this.setState({showCampaignSuccess: false})
      campaignFinished()
    }
    this.setState({showCampaignFail: false})
  }

  sawNoDestination = () => {
    this.setState({showedNoDestination: true, showNoDestination: false})
  }

  sawNoCredit = () => {
    this.setState({showedNoCredit: false, showNoCredit: false})
  }

  getRegions = () => {
    const { filters } = this.state
    const { topLevel } = filters
    let regions = []
    const regionFilterFound = topLevel.filter((item) => {
      item.field === 'region'
    })
  
    if(regionFilterFound.length > 0){
      regions = [...regionFilterFound[0].include]
    }
  
    return regions
  }
  nextButtonDisabled = () => {
    console.log('nextButtonDisabled')
    const { commonStore } = this.props
    const { filters, leadType, qualifiers, contactTypes, priceMapType, fixedCampaignName, updatingCampaign,
            amount, campaignID, activeStep, agreed, showedNoDestination, campaignName, countRequirements } = this.state
  
    const steps = getSteps();
    const { agent } = commonStore

    /*if(activeStep === steps.length - 1){
      if(!agreed){
        return true
      }
    }*/
    console.log(activeStep)
    console.log(updatingCampaign)
    switch(activeStep){
      case steps.length - 1:
        if(!agreed || campaignName === '' || campaignName === null  || campaignName === undefined){
          return true
        }else if(updatingCampaign){
          return true
        }
          return false
      case 0:
          console.log(leadType)
          if(priceMapType === null){
            return true
          }
          if(priceMapType === 'carte' && (leadType === null || leadType === undefined)){
            return true
          }

          return false

      case 1:
        let remaining = 0
        console.log('case 1')
        console.log(qualifiers)
        console.log(priceMapType)

       // if(priceMapType === 'fixed' && fixedCampaignName.length > 1){
        if(priceMapType === 'fixed'){
          return false
        }

        if(qualifiers.length < 1){
          return true
        }
        if(contactTypes.length < 1){
          return true
        }
        for(let qualifier of qualifiers ){
            console.log(qualifier)
          for(let contact of contactTypes ){
            const filterArray = filters[leadType]['qualifiers'][qualifier][contact]
            const index = filterArray.findIndex(x => x.field === 'condition:povertyLevel');
            console.log(filterArray)
              if(index > -1){
                if (filterArray[index].include.length > 1){
                  console.log('continue')
                  continue
                }
              }else{
                remaining = remaining + 1
              }
          }
        }
      
        return remaining > 0
  
      case 2:
          const { topLevel } = filters
          console.log(topLevel)
          const index = topLevel.findIndex(x => x.field === 'region');
          console.log(index)
          if(index > -1){
            console.log(topLevel[index].include.length)
            if (topLevel[index].include.length > 0){
              return false
            }
          }
          return true
      case 4:
      if(!campaignID){
        if(amount === 0 || amount > agent.credit){
          return true
        }
      }else{
        if(amount > agent.credit){
          return true
        }
      }
        return false
      default:
      return false
    }

    /*if(activeStep === 3 && !campaignID){
      if(amount === 0 || amount > agent.credit){
        return true
      }
    }*/

    return false
  }

  handleSubmit = () => {
    this.setState({updatingCampaign: true}, () => {
      this.submitCampaign()
    })
  }

  submitCampaign = debounce(() => {
    const { priceMaps, priceMap, defaults, inclusions, regions, skipped, incomplete, conditions, 
      showCampaignFail, showCampaignSuccess, updatingCampaign, ...other} = this.state

    const { authStore } = this.props
    const inclusionArray = []
    console.log(inclusions)
  
        for (let inclusion in inclusions){
          console.log(inclusion)
          inclusionArray.push(inclusions[inclusion])
        }
    
        const campaign = { ...other, inclusions: inclusionArray }
      
        authStore.updateCampaign(campaign)
        .then((result) => {
          if(result){
            this.setState({showCampaignSuccess: true})
          }else{
            this.setState({showCampaignFail: true, updatingCampaign: false})
          }
        })
    
  }, 500)

  /*handleSubmit = () => {
    const { priceMaps, priceMap, defaults, inclusions, regions, skipped, incomplete, conditions, ...other} = this.state
    const { authStore } = this.props
    const inclusionArray = []
    console.log(inclusions)
    this.setState({updatingCampaign: true})
    for (let inclusion in inclusions){
      console.log(inclusion)
      inclusionArray.push(inclusions[inclusion])
    }

    const campaign = { ...other, inclusions: inclusionArray }
  
    authStore.updateCampaign(campaign)
    .then((result) => {
      if(result){
        this.setState({showCampaignSuccess: true, updatingCampaign: false})
      }else{
        this.setState({showCampaignFail: true, updatingCampaign: false})
      }
    })
  }*/
  clearQualifier = (qualifier) => {
    const { filters, leadType } = this.state
    const newFilters = {...filters}
    console.log(leadType)
    console.log(qualifier)
    console.log({...this.makeDefaultFilters()[leadType]['qualifiers'][qualifier]})
    newFilters[leadType]['qualifiers'][qualifier] = {...this.makeDefaultFilters()[leadType]['qualifiers'][qualifier]}
    console.log(newFilters)
    this.setState({filters: newFilters})
  }
  clearContact = (contact) => {
    const { filters, leadType } = this.state
    const newFilters = {...filters}
    const qualifiers = Object.keys(this.makeDefaultFilters()[leadType]['qualifiers'])
    for (let qualifier of qualifiers){
      console.log(qualifier)
      console.log(newFilters[leadType]['qualifiers'][qualifier])
      console.log(newFilters[leadType]['qualifiers'][qualifier][contact])
      newFilters[leadType]['qualifiers'][qualifier][contact] = []
    }
    this.setState({filters: newFilters})
  }
  handleTopToggle = (type, value) => {
      
      const oldTypes = this.state[type]
      let newTypes = [...oldTypes]
      const index = oldTypes.indexOf(value)

      if(index > -1){
        newTypes.splice(index, 1);
      }else{
        newTypes.push(value)
      }
      

      if(type === 'qualifiers'){      
          this.clearQualifier(value)
      }else if (type === 'contactTypes'){
          this.clearContact(value)
      }

      this.setState({[type]: newTypes})
  }

 /* handleInclusionRemove = (field, recordType, value) => {
    const { inclusions } = this.state
    const newInclusions = {...inclusions}
    if(field in newInclusions){
        newInclusions[field] = newInclusions[field].include.filter((include) => {
            return value === include
        })
    }

    this.setState({inclusions: newInclusions})
  }

  handleInclusionAdd = (field, recordType, value) => {
    const { inclusions } = this.state
    const newInclusions = {...inclusions}
    if(field in newInclusions){
          newInclusions[field] = newInclusions[field].include.push(value)
    }else{
        
        const newInclusion = {
          "field": "povertyLevel",
          "include": [value],
          "recordType": recordType
        }

        newInclusions[field] = newInclusion
    }

    this.setState({inclusions: newInclusions})
  }*/

  handleUpdate = (field, value, inValid) => {
    const { incomplete } = this.state;
    const temp = {};
    temp[field] = value;
    if (inValid) {
      const newInc = [...incomplete, field];
      temp.incomplete = newInc;
    } else {
      const index = incomplete.indexOf(field);
      if (index > -1) {
        const newInc = incomplete.splice(index, 1);
        temp.incomplete = newInc;
      }
    }
  
    this.setState(temp);
  }

  isStepOptional = step => {
    return false
   //return step === 0;
  };

  handleNext = () => {
    const { activeStep, destinations, showedNoDestination, showedNoCredit, campaignID } = this.state;
    let { skipped } = this.state;
    const { commonStore } = this.props
    const { credit } = commonStore.agent

    if(!campaignID  && activeStep === 0 && credit < 1){

      if(!showedNoCredit){
        this.setState({showNoCredit: true})
        return
      }
    }

    if(activeStep === 3 && destinations.length === 0){
      if(!showedNoDestination){
        this.setState({showNoDestination: true})
        return
      }
    }

    if(activeStep === 5){
     this.handleSubmit()
    }else{
      if (this.isStepSkipped(activeStep)) {
        skipped = new Set(skipped.values());
        skipped.delete(activeStep);
      }
      this.setState({
        activeStep: activeStep + 1,
        skipped,
      });
    }
  };

  handleBack = () => {
    const { activeStep } = this.state;
    let { fixedCampaignName, leadType } = this.state
    if((activeStep - 1) < 1){
      fixedCampaignName = ''
      leadType = null
    }
    this.setState({
      activeStep: activeStep - 1,
      fixedCampaignName, leadType
    });
  };

  handleSkip = () => {
    const { activeStep } = this.state;
    if (!this.isStepOptional(activeStep)) {
      throw new Error("You can't skip a step that isn't optional.");
    }

    this.setState(state => {
      const skipped = new Set(state.skipped.values());
      skipped.add(activeStep);
      return {
        activeStep: state.activeStep + 1,
        skipped,
      };
    });
  };

  handleReset = () => {
    this.setState({
      activeStep: 0,
    });
  };
  isStepSkipped(step) {
    return this.state.skipped.has(step);
  }
  updateCampaignType = (priceMapType) => {
    const { commonStore, leadType: currentType } = this.props
    const { network } = commonStore
    const { types } = network
    const { leadTypes } = types
    let defaultLeadType = null
    console.log(leadTypes)
    if(leadTypes.length === 1){
      defaultLeadType = leadTypes[0]
    } 


    const filters = priceMapType === 'carte' ? this.makeDefaultFilters() : {}
    const leadType = priceMapType !== 'carte' ? null :  currentType ? currentType : defaultLeadType
    this.setState({priceMapType, filters, leadType})
  }
  updateLeadType = (leadType) => {
    let maxAgeAllowed = 86400000
    if(leadType === 'recycled'){
      maxAgeAllowed = 604800000
    }
    this.setState({leadType, maxAgeAllowed})
  }
  updateFixed = (item) => {
    console.log('updateFixed')
    console.log(item)
    this.setState({priceMapType:'fixed', leadType:'exclusive', ...item})
  }
  updateCompany = (item) => {
    this.setState({priceMapType:'company', ...item})
  }
  updateFilters = (filters) => {
    console.log('updateFilters')
    console.log(filters)
    this.setState({priceMapType:'carte', filters})
  }
  updateTopFilters = (filter) => {
    console.log('updateTopFilters')
    console.log(filter)
    const { filters } = this.state
    const { topLevel } = filters

    const newArray = []

    const foundArray = topLevel.filter((item) => {
        return item.field === filter.field
    })

    const exlcudeArray = topLevel.filter((item) => {
      return item.field !== filter.field
    })

    filters.topLevel = [...exlcudeArray, filter]

    this.setState({filters})

  }
  makeStep(step) {
    switch (step) {
      case 0:
      return <CampaignType {...this.state}  updateCampaignType={this.updateCampaignType}  updateLeadType={this.updateLeadType} handleUpdate={this.handleUpdate} />;
      case 1:
        return <Filters {...this.state} handleTopToggle={this.handleTopToggle} handleUpdate={this.handleUpdate} updateFilters={this.updateFilters} updateFixed={this.updateFixed} updateCompany={this.updateCompany}  />;
      case 2:
        return <States {...this.state} handleUpdate={this.updateTopFilters}  />;
      case 3:
        return <Destinations {...this.state} handleUpdate={this.handleUpdate} />;
      case 4:
        return <Budget {...this.state} handleUpdate={this.handleUpdate} />;
      case 5:
        return <Review {...this.state} handleUpdate={this.handleUpdate} handleSubmit={this.handleSubmit} />;
      default:
        return null;
    }
  }

  render() {
    const { classes } = this.props;
    const steps = getSteps();
    const { loading, activeStep, campaignID, agreed, showedNoCredit, showNoCredit, showedNoDestination, showNoDestination, showCampaignFail, showCampaignSuccess } = this.state;

    console.log(this.state)

    if(loading){
      return null
    }

  /*  return <AddCreditDialog open={ true } handleClose={  handleCloseForm = (values) => {
      const { syncUser } = this.props.authStore
      syncUser()
      this.setState({ showCreditDialog: false })
    }} />*/

    return (
      <div className={classes.root}>
        <Stepper activeStep={activeStep}>
          {steps.map((label, index) => {
            const props = {};
            const labelProps = {};
            if (this.isStepOptional(index)) {
              labelProps.optional = <Typography variant="caption">Optional</Typography>;
            }
            if (this.isStepSkipped(index)) {
              props.completed = false;
            }
            return (
              <Step key={label} {...props}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        <div>
          {activeStep === steps.length ? (
            <div>
            
              <Typography className={classes.instructions}>
                All steps completed - you&quot;re finished
              </Typography>
             
              <Button onClick={this.handleReset} className={classes.button}>
                Reset
              </Button>
              </div>
          ) : (
            <div>
              {this.makeStep(activeStep)}
              <div>
                <Button
                  disabled={activeStep === 0}
                  onClick={this.handleBack}
                  className={classes.button}
                  disabled={loading}
                >
                  Back
                </Button>
                {this.isStepOptional(activeStep) && (
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={this.handleSkip}
                    className={classes.button}
                    disabled={loading}
                  >
                    Skip
                  </Button>
                )}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={this.handleNext}
                  className={classes.button}
                  disabled={this.nextButtonDisabled()}
                >
                  {activeStep === steps.length - 1 ? campaignID ? 'Update Campaign': 'Add Campaign' : 'Next'}
                </Button>
              </div>
            </div>
          )}
        </div>
            <NoCreditDialog open={showNoCredit} close={this.sawNoCredit}/>
            <NoDestinationDialog open={showNoDestination} close={this.sawNoDestination}/>
            <CampiagnFailureDialog open={showCampaignFail} close={() =>  this.closeCampaignDialog(false)}/>
            <CampiagnSuccessfulDialog open={showCampaignSuccess} close={() => this.closeCampaignDialog(true)}/>
        </div>
    );
  }
}


CampaignSetup.propTypes = {
  classes: PropTypes.object,
};

export default withStyles(styles)(CampaignSetup);



// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/ManageCampaign/CampaignSetup.js